import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import bind from 'bind-decorator';
import pluralize from 'pluralize';
import {
  Button,
  Dropdown,
  Modal,
} from 'semantic-ui-react';
import LessonTag from '../../models/lesson_tag';

class LessonTagModal extends Component {
  static propTypes = {
    toggleModal: PropTypes.func,
    showModal: PropTypes.bool,
    tagLessons: PropTypes.func,
    count: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      tags: [],
      value: [],
    };
  }

  async componentDidMount() {
    const tags = await LessonTag.objects().all();
    this.setState({ tags });
  }

  @bind
  handleChange(e, { value }) {
    this.setState({
      value,
    });
  }

  @bind
  handleAddItem(e, { value }) {
    const { tags } = this.state;
    const newTag = new LessonTag();
    newTag.name = value;
    tags.push(newTag);
    this.setState({ tags });
  }

  render() {
    const tagOptions = this.state.tags.map((tag) => ({ value: tag.name, text: tag.name }));
    return (
      <Modal
        onClose={this.props.toggleModal}
        open={this.props.showModal}
        style={{ maxWidth: '500px' }}
        closeIcon
      >
        <Modal.Header>Tag {this.props.count} {pluralize('Lesson', this.props.count)}</Modal.Header>
        <Modal.Content>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Dropdown
              search
              selection
              multiple
              allowAdditions
              additionLabel="Create Tag: "
              onChange={this.handleChange}
              onAddItem={this.handleAddItem}
              options={tagOptions}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={() => {
              this.props.tagLessons(this.state.value);
            }}
          >
            Submit
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default Radium(LessonTagModal);
